export const EVENT_LABELS = {
  TELEMETRIA_INICIO: "Telemetria iniciada",
  TELEMETRIA_FIM: "Telemetria encerrada",
  TELEMETRIA_AMOSTRA: "Amostra de telemetria",
  ASSUMIR_MAQUINA: "Assumir máquina",
  FINALIZAR_TRABALHO: "Finalizar trabalho",
  ABASTECIMENTO: "Abastecimento",
  MANUTENCAO: "Manutenção",
  MANUTENCAO_EXECUTADA: "Manutenção executada",
  CHECK_CALIBRAGEM: "Check de calibragem",
  RELATO_DIA: "Relato do dia",
  PERDA_COLHEITA_AMOSTRA: "Amostra de perda de colheita",
  PONTO_INTERESSE: "Ponto de interesse",
  CLIMA: "Clima",
  INSUMOS_BASE_TRABALHO: "Início do trabalho (insumos)",
  INSUMOS_BASE_BACIA: "Parada de abastecimento (insumos)",
};

export const RECORD_TYPE_LABELS = {
  operational_event: "Evento operacional",
  telemetry_sample: "Telemetria",
  input_refill_work: "Trabalho de insumos",
  input_refill_record: "Parada de insumos",
  fuel_record: "Abastecimento",
};

export const FIELD_LABELS = {
  tipo_evento: "Tipo de evento",
  id_maquina: "Máquina",
  nome_maquina: "Máquina",
  id_operador: "CPF operador",
  valor_principal: "Valor principal",
  horimetro_maquina: "Horímetro",
  horimetro: "Horímetro",
  horimetro_inicial: "Horímetro inicial",
  horas_ate_proxima: "Próxima manutenção em (horas)",
  horimetro_alvo: "Horímetro alvo",
  intervalo_horas: "Intervalo (horas)",
  tanque_cheio: "Tanque cheio",
  observacoes: "Observações",
  nome_trabalho: "Nome do trabalho",
  tipo_operacao: "Tipo de operação",
  hectares_painel_inicial: "Hectares painel (início)",
  hectares_painel: "Hectares painel",
  hectares_bacia: "Hectares no trecho",
  taxa_alvo_adubo_kg_ha: "Taxa-alvo adubo (kg/ha)",
  taxa_alvo_semente_kg_ha: "Taxa-alvo semente (kg/ha)",
  taxa_alvo_defensivo_l_ha: "Taxa-alvo defensivo (L/ha)",
  informacoes_produto: "Informações do produto",
  produto: "Produto",
  taxa_alvo_l_ha: "Taxa-alvo (L/ha ou kg/ha)",
  quantidade_por_abastecimento: "Quantidade por abastecimento",
  semente_quantidade: "Semente colocada na plantadeira",
  semente_unidade: "Unidade da semente",
  hectares_feitos: "Hectares feitos com o tanque",
  taxa_aplicada_l_ha: "Taxa aplicada (L/ha)",
  taxa_alvo_semente: "Taxa-alvo semente",
  taxa_aplicada_adubo_kg_ha: "Adubo aplicado (kg/ha)",
  taxa_aplicada_semente: "Semente aplicada",
  coleta_adubo_kg_ha: "Coleta de adubo (kg/ha)",
  coleta_distancia_m: "Coleta — distância (m)",
  coleta_espacamento_cm: "Coleta — espaçamento (cm)",
  hectares_painel: "Hectares no painel",
  hectares_painel_inicial: "Hectares no painel (início)",
  hectares_plantados: "Hectares plantados (calculados)",
  taxa_aplicada_semente_mil_ha: "Semente aplicada (mil/ha)",
  sementes_por_metro_aplicadas: "Sementes por metro (aplicadas)",
  inoculante_l: "Inoculante colocado (L)",
  taxa_alvo_inoculante_l_ha: "Taxa-alvo inoculante (L/ha)",
  taxa_aplicada_inoculante_l_ha: "Inoculante aplicado (L/ha)",
  abastecidas_ultimas_3_contagem: "Abastecidas na média (últimas 3)",
  abastecidas_total_contagem: "Abastecidas no total",
  media_ultimas_3_hectares: "Hectares das últimas 3 abastecidas",
  media_total_hectares: "Hectares totais das abastecidas",
  media_ultimas_3_ha_h: "Média últimas 3 — ritmo (ha/h)",
  media_total_ha_h: "Média total — ritmo (ha/h)",
  media_ultimas_3_adubo_kg_ha: "Média últimas 3 — adubo (kg/ha)",
  media_total_adubo_kg_ha: "Média total — adubo (kg/ha)",
  media_ultimas_3_semente_mil_ha: "Média últimas 3 — semente (mil/ha)",
  media_total_semente_mil_ha: "Média total — semente (mil/ha)",
  media_ultimas_3_sementes_m: "Média últimas 3 — sementes/m",
  media_total_sementes_m: "Média total — sementes/m",
  media_ultimas_3_inoculante_l_ha: "Média últimas 3 — inoculante (L/ha)",
  media_total_inoculante_l_ha: "Média total — inoculante (L/ha)",
  fora_da_tolerancia: "Fora da tolerância",
  ordem_servico_id: "Ordem de serviço",
  nome_maquina_colheita: "Máquina de colheita",
  maquina_colheita: "Máquina de colheita",
  sementes_contadas: "Sementes contadas",
  pms_g: "PMS (g)",
  perda_kg_ha: "Perda (kg/ha)",
  perda_sacas_ha: "Perda (sc/ha)",
  repeticao: "Repetição",
  kg_por_saca: "Peso da saca (kg)",
  vinculo_rastreamento: "Vinculado ao rastreamento",
  adubo_kg: "Adubo (kg)",
  semente_kg: "Semente (kg)",
  defensivo_l: "Defensivo (L)",
  trabalho_id_local: "Trabalho (id local)",
  iniciado_em_utc: "Início do trabalho",
  registrado_em_utc: "Registrado em",
  timestamp_utc: "Data/hora",
  velocidade_kmh: "Velocidade (km/h)",
  velocidade_ms: "Velocidade (m/s)",
  tc: "Rumo (°)",
  movimento: "Movimento",
  fonte_dados: "Fonte dos dados",
  precisao_gps: "Precisão GPS (m)",
  localizacao: "Localização",
  latitude: "Latitude",
  longitude: "Longitude",
  tipo_ponto: "Tipo do ponto",
  rotulo: "Rótulo",
  observacao: "Observação",
  session_id: "Sessão",
  relato: "Relato",
  description: "Descrição",
  titulo: "Título da operação",
  title: "Título da operação",
  work_started_at: "Início do trabalho",
  work_ended_at: "Fim do trabalho",
  applied_amount: "Quantidade aplicada",
  applied_unit: "Unidade",
  erro_ingestao: "Erro ao processar",
};

export function eventLabel(code) {
  if (!code) return "Registro";
  return EVENT_LABELS[code] || code.replace(/_/g, " ");
}

export function recordTypeLabel(code) {
  if (!code) return "Registro";
  return RECORD_TYPE_LABELS[code] || code.replace(/_/g, " ");
}

export function fieldLabel(key) {
  return FIELD_LABELS[key] || key.replace(/_/g, " ");
}

export function formatDetailValue(key, value) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Sim" : "Não";
  if (key === "fora_da_tolerancia") {
    if (value === true || value === 1 || value === "1") return "Sim";
    if (value === false || value === 0 || value === "0") return "Não";
  }
  if (key === "tanque_cheio") {
    if (value === true || value === 1 || value === "1") return "Sim (completo)";
    if (value === false || value === 0 || value === "0") return "Não (parcial)";
  }
  if (key === "valor_principal" && !Number.isNaN(Number(value))) {
    return `${Number(value).toLocaleString("pt-BR")} L`;
  }
  if (
    (key === "velocidade_kmh" || key === "velocidade_ms") &&
    !Number.isNaN(Number(value))
  ) {
    const unit = key === "velocidade_kmh" ? " km/h" : " m/s";
    return `${Number(value).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}${unit}`;
  }
  if (typeof value === "object") {
    if (value.latitude != null && value.longitude != null) {
      return `${Number(value.latitude).toFixed(6)}, ${Number(value.longitude).toFixed(6)}`;
    }
    return JSON.stringify(value);
  }
  return String(value);
}
